/* eslint-disable no-undef */
import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Card,
    CardMedia,
    CardContent,
    Typography,
    CardActions,
    Box,
    Button,
    IconButton
} from '@mui/material';
import './productCard.css';
import { ReactComponent as XSquare } from '../../assets/icons/x-square.svg'
import { ReactComponent as Clock } from '../../assets/icons/clock.svg'
import { ReactComponent as Globe } from '../../assets/icons/globe.svg'
import { ReactComponent as Edit } from '../../assets/icons/edit-2.svg'
import { ReactComponent as Trash } from '../../assets/icons/trash.svg'
import CheckoutContext from '../CheckoutContext/checkoutContext';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { getAssistantsString } from '../../utils/checkout';
import { useDispatch, useSelector } from 'react-redux';
import { remove as removeAction, selectProductTotal } from '../../app/features/cartSlice';
import { useNavigate } from 'react-router-dom';

const ProductCard2 = ({
    data,
    isCart = false,
    isCartModal = false,
    showPrice = true,
}) => {

    const { t, i18n } = useTranslation(['tours', 'paths', 'components']);
    const context = useContext(CheckoutContext);
    const dispatch = useDispatch();
    const tours = useSelector(state => state.cart.checkout.tours.length);
    let {
        name,
        cover,
        city,
        country,
        booking,
        date,
        slug,
        edit,
        remove
    } = data;

    const currency = data?.currency?.symbol || data?.tourDetails?.currency?.symbol || '€';
    const total = useSelector((state) => selectProductTotal(state, name));
    const isSpanish = i18n.language?.toLowerCase().startsWith('es');
    const desktopDateFormat = isSpanish ? 'dddd, D [de] MMMM' : 'dddd, MMMM D';
    const mobileDateFormat = isSpanish ? 'dddd, D [de] MMMM [de] YYYY' : 'dddd, MMMM D, YYYY';

    useEffect(() => {
        dayjs.locale(isSpanish ? 'es' : 'en');
    }, [isSpanish]);



    edit = (edit === undefined) ? true : false;
    let removeIcon = (remove === undefined) ? true : false;
    const navigate = useNavigate();


    return (
        <Card
            id="product-card-2"
            sx={{
                display: { xs: 'block', md: 'flex' },
                height: { xs: '330px', md: 'auto' },
                pr: { xs: 0, md: '10px' },
                my: '15px',
                borderRadius: '8px',
                boxShadow: '0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12)'
            }}>
            <CardMedia
                sx={{
                    width: { xs: '100%', md: '160px' },
                    height: { xs: '140px', md: 'auto' }
                }}
                image={cover}
                title={name}
            />
            <Box
                sx={{
                    width: '100%',
                    display: { xs: 'block', md: 'flex' },
                    flexDirection: 'column'
                }}
            >
                <CardContent
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        pr: '4px'
                    }}
                >
                    <Typography
                        sx={{ fontSize: '18px!important' }}
                        variant="subtitle1"
                        component="span"
                    >{name}</Typography>
                    {/* {moreDetails && <Button
                        sx={{
                            fontSize: {xs: '9px', md: '10px'},
                            py: '2px',
                            height: {xs: 'fit-content', md: 'auto'}
                        }}
                        variant="contained"
                    >Ver más</Button>} */}
                    <Box
                        sx={{
                            display: 'flex'
                        }}
                    >
                        {edit && <IconButton
                            onClick={() => { context.handleEditTour(name) }}
                            aria-label='Editar'
                            sx={{
                                height: '17px',
                                px: '3px',
                                py: 0
                            }}
                        >
                            <Edit />
                        </IconButton>}
                        {removeIcon && <IconButton
                            onClick={() => {
                                dispatch(removeAction(slug));
                            }}
                            aria-label='Remover'
                            sx={{
                                height: '17px',
                                px: '3px',
                                py: 0
                            }}
                        >
                            <Trash />
                        </IconButton>}
                    </Box>
                </CardContent>
                {true && <CardContent sx={{ pt: '0px', pb: '12px' }}>
                    <Typography
                        sx={{
                            display: { xs: 'none', md: 'block' },
                            fontSize: '13px',
                            height: '40px',
                            overflow: 'hidden'
                        }}
                        variant='body2'
                        component='p'
                    >{dayjs(date).format(desktopDateFormat)}</Typography>
                    <Typography
                        sx={{
                            display: { xs: 'block', md: 'none' },
                            fontSize: '13px',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis'
                        }}
                        variant='body2'
                        component='p'
                    >{dayjs(date).format(mobileDateFormat)}</Typography>
                </CardContent>}
                <CardActions sx={{ pl: '16px', py: 0, display: 'flex', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'block' }}>
                        {(date || booking) && <Box
                            sx={{
                                display: 'block',
                                py: 0,
                                pb: '10px'
                            }}
                        >
                            {date && <Typography
                                variant='body2'
                                component='p'
                                sx={{ fontSize: '13px' }}
                            >{dayjs(date).format('MMMM D, YYYY')}</Typography>}
                            {booking && <Typography
                                variant='body2'
                                component='p'
                                sx={{
                                    ml: '0!important',
                                    fontSize: '13px'
                                }}
                            >{getAssistantsString(booking)}</Typography>}
                        </Box>}
                        {/* {(cancelable || time || languages) && !isCartModal && <Box
                            sx={{
                                display: { xs: 'none', md: 'flex' },
                                mb: '10px'
                            }}
                        >
                            {cancelable && <>
                                <XSquare />
                                <Typography
                                    variant='body2'
                                    component='p'
                                    color='secondary'
                                >&nbsp;Cancelación gratuita&nbsp;</Typography>
                            </>}
                            {time && <>
                                <Clock />
                                <Typography
                                    variant='body2'
                                    component='p'
                                    color='secondary'
                                >&nbsp;{time}&nbsp;</Typography>
                            </>}
                            {languages && <>
                                <Globe />
                                <Typography
                                    variant='body2'
                                    component='p'
                                    color='secondary'
                                >&nbsp;Idiomas: {languages}</Typography>
                            </>}
                        </Box>} */}
                        {/* {cancelable && <Box sx={{
                            display: { xs: 'flex', md: 'none' },
                            ml: '0px!important'
                        }}>
                            <XSquare />
                            <Typography
                                variant='body2'
                                component='p'
                                color='secondary'
                            >&nbsp;Cancelación gratuita&nbsp;</Typography>
                        </Box>} */}
                        {/* {(rate || reviews) && <Box sx={{ display: 'flex', mt: '15px' }}>
                            {rate && <Box
                                sx={{
                                    width: 40,
                                    height: 28,
                                    borderRadius: 2,
                                    bgcolor: 'primary.main',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                <Typography
                                    variant="h6"
                                    color="primary.contrastText"
                                    sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                                    {rate}
                                </Typography>
                            </Box>}
                            {reviews && <>
                                <Typography
                                    mb={2}
                                    pl={1}
                                    fontFamily={'Poppins'}
                                    sx={{
                                        display: { xs: 'none', md: 'flex' },
                                        lineHeight: '1.9'
                                    }}>
                                    {`${reviews.state}`}
                                </Typography>
                                <Typography
                                    mb={2}
                                    fontFamily={'Poppins'}
                                    sx={{
                                        fontSize: { xs: '14px', md: '16px' },
                                        lineHeight: '1.9'
                                    }}>
                                    {`(${reviews.number} Reviews)`}
                                </Typography>
                            </>}
                        </Box>} */}
                    </Box>
                    {showPrice &&

                        <Box>
                            <Typography
                                sx={{
                                    fontSize: { xs: '14px', md: '18px' },
                                    fontWeight: { xs: 600, md: 700 },
                                    color: 'secondary.main'
                                }}>
                                {isCart || isCartModal ? `${total} ${currency}` : `${t('from')} ${total} ${currency}`}
                            </Typography>
                            <Typography
                                color="grayText"
                                sx={{
                                    textAlign: 'right',
                                    fontSize: { xs: '10px', md: '12px' },
                                    fontWeight: 400
                                }}>
                                {data?.price?.tax > 0 ? t('IVANotincluded') : ''}
                            </Typography>
                        </Box>
                    }
                </CardActions>
            </Box>
        </Card>
    )
};

export default ProductCard2;
